"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrossellModule = void 0;
var useCrossellModule_hook_1 = require("./useCrossellModule.hook");
Object.defineProperty(exports, "useCrossellModule", { enumerable: true, get: function () { return useCrossellModule_hook_1.useCrossellModule; } });
//# sourceMappingURL=index.js.map